import { Hero } from '../components/Hero';
import { CustomerPersonas } from '../components/CustomerPersonas';
import { ServicesGrid } from '../components/ServicesGrid';
import { Workflow } from '../components/Workflow';
import { Testimonials } from '../components/Testimonials';
import { CTABanner } from '../components/CTABanner';
import { useNavigate } from 'react-router-dom';

export function HomePage() {
  const navigate = useNavigate();

  const handleNavigateToServices = () => {
    navigate('/services');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateToBooking = (serviceId?: string) => {
    navigate('/booking', { state: { preSelectedService: serviceId, isPaidSession: false } });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateToServicePage = (servicePath: string) => {
    navigate(servicePath);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      <Hero onNavigateToServices={handleNavigateToServices} onNavigateToBooking={handleNavigateToBooking} />
      <CustomerPersonas />
      <ServicesGrid 
        onNavigateToServices={handleNavigateToServices}
        onNavigateToSchoolSupport={() => handleNavigateToServicePage('/services/school-family-support')}
        onNavigateToLegalSupport={() => handleNavigateToServicePage('/services/legal-support')}
        onNavigateToRealEstate={() => handleNavigateToServicePage('/services/real-estate')}
        onNavigateToHomeManagement={() => handleNavigateToServicePage('/services/home-management')}
        onNavigateToSpiritualWellness={() => handleNavigateToServicePage('/services/spiritual-wellness')}
        onNavigateToBusinessConsulting={() => handleNavigateToServicePage('/services/business-consulting')}
        onNavigateToBeverageDevelopment={() => handleNavigateToServicePage('/services/beverage-development')}
        onNavigateToEliteConcierge={() => handleNavigateToServicePage('/services/elite-concierge')}
      />
      <Workflow />
      <Testimonials />
      <CTABanner onNavigateToBooking={handleNavigateToBooking} />
    </div>
  );
}
